import { useContext } from "react";
import { userAuthContext } from "../../ContextAPI/isAuth";
import {
  AiFillYoutube,
  AiFillFacebook,
  AiFillInstagram,
  AiFillHome,
  AiOutlineLogin,
  AiOutlineLogout,
  AiFillInfoCircle
} from "react-icons/ai";
import { BiDonateBlood } from "react-icons/bi";

import { IoMdContacts } from "react-icons/io";
import { CgProfile } from "react-icons/cg";
import { Link } from "react-router-dom";
import logoIMG from "../../Assets/Logop.png";
import "./styles.css";
const Header = () => {
  const [isAuth, setIsAuth] = useContext(userAuthContext);
  const logOut = () => {
    localStorage.removeItem("tkn");
    setIsAuth(false);
  };
  return (
    <header>
      <div className="container">
        <div className="header__container">
          <div className="logo hide-md">
            <div className="logo__image">
              <img style={{ width: "50px" }} src={logoIMG} alt="logo" />
            </div>
          </div>
          <nav className="nav-md">
            <ul>
              <li>
                <Link className="active" to="/">
                  <span className="hide-md">Accueil</span>
                  <div className="icon hide-lg">
                    <AiFillHome />
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/about">
                  <span className="hide-md">A Propose</span>
                  <div className="icon hide-lg">
                    <AiFillInfoCircle />
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/findmatch">
                  <span className="hide-md">Correspondance</span>
                  <div className="icon hide-lg">
                    <BiDonateBlood />
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/contact">
                  <span className="hide-md">Contactez Nous</span>
                  <div className="icon hide-lg">
                    <IoMdContacts />
                  </div>
                </Link>
              </li>

              {isAuth ? (
                <>
                  <li>
                    <Link className="hide-md" to="/profile">
                      <span className="hide-md">Profile</span>
                      <div className="icon hide-lg">
                        <CgProfile />
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link className="login hide-md" to="/" onClick={logOut}>
                      <span className="hide-md">Se déconnecter</span>
                      <div className="icon hide-lg">
                        <AiOutlineLogout />
                      </div>
                    </Link>
                  </li>
                </>
              ) : (
                <li>
                  <Link className="login hide-md" to="/auth">
                    <span className="hide-md">S'identifier</span>
                    <div className="icon hide-lg">
                      <AiOutlineLogin />
                    </div>
                  </Link>
                </li>
              )}
            </ul>
          </nav>
          <div className="social-media hide-md">
            <ul>
              <li>
                <a href="http://" target="_blank" rel="noopener noreferrer">
                  <AiFillYoutube />
                </a>
              </li>
              <li>
                <a href="http://" target="_blank" rel="noopener noreferrer">
                  <AiFillFacebook />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/rbeh_ma/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
